import { provideHttpClient, withInterceptors } from '@angular/common/http'

import { authInterceptor } from '@yoshu-lib/core/http/auth.interceptor'
import { errorInterceptor } from '@yoshu-lib/core/http/error.interceptor'
import { localeInterceptor } from '@yoshu-lib/core/http/locale.interceptor'
import { trailingSlashInterceptor } from '@yoshu-lib/core/http/trailing-slash.interceptor'

import { devLoginInterceptor } from './dev-login.interceptor'

export const provideCotyHttp = () =>
  provideHttpClient(
    withInterceptors([
      devLoginInterceptor,
      trailingSlashInterceptor,
      localeInterceptor,
      errorInterceptor,
      authInterceptor
    ])
  )
